enum ChargeRepaymentProvider {
  HIGHNOTE = "HIGHNOTE",
  OATFI = "OATFI",
}

export default ChargeRepaymentProvider;
